import {lighten} from 'polished';
import {createGlobalStyle} from 'styled-components';

import {colors} from 'lib/colors';

const nProgressColor = lighten(0.3, colors.primary);

export const GlobalStyle = createGlobalStyle`
  ul {
    margin: 0;
    padding: 0;
  }

  .ant-table-placeholder {
    min-height: 100px;
  }

  .awsappsync {
    height: 100%;
  }

  .ant-form-explain, .ant-form-extra {
    font-size: 0.95em;
  }

  #nprogress {
    pointer-events: none;

    .bar {
      background: ${nProgressColor};
      position: fixed;
      z-index: 2048;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 2px;
    }

    .peg {
      display: block;
      position: absolute;
      right: 0;
      width: 100px;
      height: 100%;
      box-shadow: 0 0 10px ${nProgressColor}, 0 0 5px ${nProgressColor};
      opacity: 1;
      transform: rotate(3deg) translate(0, -4px);
    }

    .spinner {
      display: block;
      position: fixed;
      z-index: 1031;
      top: 15px;
      right: 15px;
    }

    .spinner-icon {
      width: 18px;
      height: 18px;
      box-sizing: border-box;
      border: solid 2px transparent;
      border-top-color: ${nProgressColor};
      border-left-color: ${nProgressColor};
      border-radius: 50%;
      animation: nprogress-spinner 400ms linear infinite;
    }
  }

  .nprogress-custom-parent {
    overflow: hidden;
    position: relative;

    #nprogress {
      .bar,
      .spinner {
        position: absolute;
      }
    }
  }

  @keyframes nprogress-spinner {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  .ant-typography {
    & ol li, & ul li {
      margin-bottom: 1em !important;
    }
  }

  .ant-card, .ant-layout-header {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  }

  .ant-descriptions-small .ant-descriptions-row > th, .ant-descriptions-small .ant-descriptions-row > td {
    padding-bottom: 0 !important;
  }

  .ant-card-extra {
    padding: 0;
  }

  .clickable {
    cursor: pointer;
  }

  .grayed-out {
    background: #F9F9F9 !important;
    color: rgba(0, 0, 0, 0.65)
  }

  .minimized-cell {
    width: 1px;
    white-space: nowrap;
  }

  .no-wrap {
    white-space: nowrap;
  }

  .status-tag {
    display: grid;
    width: auto;
    text-align: center;
  }

  .word-break-all {
    word-break: break-all;
  }

  .ant-btn.ant-btn-loading {
    .anticon:not(.anticon-loading) {
      visibility: hidden;
    }
  }

  .ant-table-row.disabled > td {
    background: #f7fafc;
  }

  .ant-form-item-label > label {
    display: flex;
  }

  .ant-form label:not(.ant-radio-wrapper,.ant-checkbox-wrapper) {
    font-weight: 500;
    display: flex;
    align-items: center;
  }

  .ant-form-item {
    transition: none !important;
  }

  .grecaptcha-badge {
    visibility: hidden !important;
  }

  .simple-table {
    td {
      padding: 0 10px 5px;
      vertical-align: top;
    }

    td:first-child {
      padding-left: 0;
    }

    td:last-child {
      padding-right: 0;
    }

    tr:last-child td {
      padding-bottom: 0;
    }
  }
`;
